import { Grid, TextField, Typography, useTheme } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/styles";
import CurrencyTextField from "@unicef/material-ui-currency-textfield";
import ColorButton from "components/common/ColorButton";
import ContractTermSection from "components/request-document/components/ContractTermSection";
import { useFormik } from "formik";
import useModalLoading from "libs/hooks/useModalLoading";
import usePrevious from "libs/hooks/usePrevious";
import { getErrorMessage, isError, mapFieldValidate } from "libs/utils/form";
import { formatPrice } from "libs/utils/format";
import { get, isNaN } from "lodash";
import mrz from "mrz";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMasterData } from "redux/modules/masterSlice";
import {
  ocrContractTermSlice,
  ocrSalarySlice,
  readOCRAllowance,
  readOCRBenefit,
  readOCRBonus,
  readOCRContractTerm,
  readOCRSalary,
  selectOCRAllowance,
  selectOCRBenefit,
  selectOCRBonus,
  selectOCRContractTerm,
  selectOCRSalary
} from "redux/modules/ocrSlice";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import {
  addPopupSmartForm,
  addSmartFormSlice,
  getCoditionType,
  getCoditionVisa,
  getSmartForm,
  getSmartFormFieldConfig,
  selectAddSmartForm,
  selectCoditionType,
  selectCoditionVisa,
  selectCurrentSmartServiceId,
  selectSmartFormFieldConfig,
  setConditionType
} from "redux/modules/visaForm";
import MasterService from "services/MasterService";
import * as yup from "yup";

const x = mrz.parse;

const ConditionType = {
  Company: "Company",
  Government: "Government",
};

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: "18px 48px",
  },
  title: {
    color: theme.palette.darkIndigo.main,
  },
  label: {
    color: "#172b4d",
    height: 34,
  },
  formControl: {
    margin: theme.spacing(1),
    display: "flex",
    flex: 1,
  },
  currencyCode: {
    margin: theme.spacing(1),
    width: 100,
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  buttonUpload: {
    margin: theme.spacing(1),
    height: 54,
    width: 140,
    border: "1px solid rgba(0, 0, 0, 0.23);",
    color: theme.palette.secondary.main,
  },
  uploadStatus: {
    display: "flex",
    flex: 1,
    margin: theme.spacing(1),
    height: 54,
    borderRadius: 7,
    border: "1px solid rgba(0, 0, 0, 0.23);",
    alignItems: "center",
    padding: "0px 17px",
  },
  bulletStatus: {
    width: 18,
    height: 18,
    borderRadius: 18,
    marginRight: theme.spacing(1),
  },
  errorText: {
    marginLeft: theme.spacing(3),
  },
}));

// status: idle | recognizing | found | notFound
function UploadStatus({ status = "idle", progress = 0 }) {
  const classes = useStyles();
  const theme = useTheme();

  const statusColor = {
    idle: theme.palette.primary.main,
    recognizing: theme.palette.secondary.main,
    found: theme.palette.success.main,
    notFound: theme.palette.warning.main,
  }[status];

  const statusText = {
    idle: "Idle",
    recognizing: "Recognizing...",
    found: "Found detection",
    notFound: "Not detected",
  }[status];

  return (
    <div className={classes.uploadStatus}>
      {status === "recognizing" ? (
        <CircularProgress
          style={{ color: statusColor, marginRight: theme.spacing(1) }}
          size={18}
          value={(progress || 0.1) * 100}
          variant="determinate"
        />
      ) : (
        <span
          className={classes.bulletStatus}
          style={{ backgroundColor: statusColor }}
        />
      )}
      <Typography style={{ color: statusColor }}>{statusText}</Typography>
    </div>
  );
}

function UploadButton({ id, onChange, ...props }) {
  const classes = useStyles();
  return (
    <div>
      <input
        style={{ display: "none" }}
        id={`contained-button-file-${id}`}
        type="file"
        disabled={props.disabled}
        onChange={onChange}
        onClick={(event) => {
          event.target.value = null;
        }}
      />
      <label htmlFor={`contained-button-file-${id}`}>
        <ColorButton
          component="span"
          fullWidth={false}
          classes={{ root: classes.buttonUpload }}
          variant="outlined"
          {...props}
        >
          BROWSE
        </ColorButton>
      </label>
    </div>
  );
}

export default function RequestTalentForma({
  onCancel = () => { },
  onSubmit = () => { },
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const modalLoading = useModalLoading();

  const personalDetailState = useSelector(selectPersonalDetail);
  const smartVisaServiceId = useSelector(selectCurrentSmartServiceId);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const fieldConfigState = useSelector(selectSmartFormFieldConfig);
  const coditionType = useSelector(selectCoditionType);
  const {
    isLoading,
    isSuccess,
    data: coditionVisa,
  } = useSelector(selectCoditionVisa);

  useEffect(() => {
    if (addSmartFormState.isLoading) {
      modalLoading.showLoading();
    } else {
      if (addSmartFormState.isSuccess) {
        modalLoading.hideLoading();
        onSubmit();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      } else if (addSmartFormState.isFailure) {
        modalLoading.hideLoading();
        alert(JSON.stringify(addSmartFormState.error));
      }
    }
  }, [
    addSmartFormState.error,
    addSmartFormState.isFailure,
    addSmartFormState.isLoading,
    addSmartFormState.isSuccess,
    dispatch,
    modalLoading,
    onSubmit,
  ]);

  useEffect(() => {
    if (smartVisaServiceId) {
      dispatch(
        getMasterData({ CurrencyCode: true, OrganiztionTypeConfig: true })
      );
      dispatch(
        getCoditionVisa({
          smartVisaServiceId,
          ConditionType: ConditionType.Company,
        })
      );
      dispatch(getCoditionType({ smartserviceId: smartVisaServiceId }));
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartVisaServiceId }));
      dispatch(ocrSalarySlice.actions.clearAll());
      dispatch(ocrContractTermSlice.actions.clearAll());
    }
  }, [dispatch, smartVisaServiceId]);

  // = Allowance, Benefit, Bonus
  const getFieldConfigByName = (fieldName) =>
    get(coditionVisa, "defaultType", []).find(
      (codition) => codition.conditionField === fieldName
    );

  const salaryFieldConfig = getFieldConfigByName("Salary");
  const contractTermFieldConfig = getFieldConfigByName("Contract Term");
  const allowanceFieldConfig = getFieldConfigByName("Allowance");
  const benefitFieldConfig = getFieldConfigByName("Benefit");
  const bonusFieldConfig = getFieldConfigByName("Bonus");

  const extraField = get(coditionVisa, "extraType", []);

  const masterState = useSelector((state) => state.master);
  const masterData = useSelector((state) => state.master.list);
  const exchangeRate = useSelector((state) => state.master.exchangeRate);

  const currencyCode = get(masterData, "currencyCode", []);
  const organiztionTypeConfig = get(masterData, "organiztionTypeConfig", []);

  const salaryMin = get(salaryFieldConfig, "conditionValueMax", "0");
  const contractTermMin = get(salaryFieldConfig, "conditionValueMax", "0");
  const allowanceMin = get(allowanceFieldConfig, "conditionValueMax", "0");
  const benefitMin = get(benefitFieldConfig, "conditionValueMax", "0");
  const bonusMin = get(bonusFieldConfig, "conditionValueMax", "0");

  const [rates, setRates] = useState({
    Salary: {},
    Allowance: {},
    Benefit: {},
    Bonus: {},
  });

  const getAmountFieldSpec = (fieldName, min = 0, required = true) => {
    if (required) {
      return yup
        .number(`Enter your ${fieldName.toLocaleLowerCase()}`)
        .transform((value) => (isNaN(value) ? undefined : value))
        .nullable()
        .test({
          name: "min",
          exclusive: false,
          params: {},
          message: `${fieldName} should more than ${formatPrice(min)} bath`,
          test: function (value) {
            // You can access the price field with `this.parent`.
            const covertPrice =
              parseFloat(value || 0) * get(rates[fieldName], "rate", 0);

            return parseFloat(min) <= covertPrice;
          },
        })
        .required(`${fieldName}  is required`);
    }

    return yup
      .number(`Enter your ${fieldName.toLocaleLowerCase()}`)
      .transform((value) => (isNaN(value) ? undefined : value))
      .nullable()
      .test({
        name: "min",
        exclusive: false,
        params: {},
        message: `${fieldName} should more than ${formatPrice(min)} bath`,
        test: function (value) {
          // console.log(fieldName);
          // You can access the price field with `this.parent`.
          const covertPrice = (value || 0) * get(rates[fieldName], "rate", 0);
          return parseFloat(min) <= covertPrice;
        },
      });
  };

  const validationSchema = yup.object({
    ...(salaryFieldConfig && {
      salary: getAmountFieldSpec("Salary", salaryMin),
      CurrencySalary: yup.string(),
      salaryFile: yup.mixed().required("Please upload salary file"),
    }),
    ...(contractTermFieldConfig && {
      ContractTermType: yup.string().required(),
      ContractTermFile: yup
        .mixed()
        .required("Please upload contract term file"),
      ContractYear: yup.string().when("ContractTermType", {
        is: "Y",
        then: yup.string().required("Year is required"),
      }),
      ContractMonth: yup.string().when("ContractTermType", {
        is: "Y",
        then: yup.string().required("Month is required"),
      }),
      ContractPeriodFrom: yup.string().when("ContractTermType", {
        is: "P",
        then: yup.string().required("Start date is required"),
      }),
      ContractPeriodTo: yup.string().when("ContractTermType", {
        is: "P",
        then: yup.string().required("End date is required"),
      }),
      ContractOther: yup.string().when("ContractTermType", {
        is: "O",
        then: yup.string().required("Please enter other detail."),
      }),
    }),
    AverageIncomeBaht: yup.string(),
    ...(allowanceFieldConfig && {
      Allowance: getAmountFieldSpec("Allowance", allowanceMin, false),
      CurrencyCodeAllowance: yup.string(),
      allowanceFile: yup.mixed(),
      // allowanceFile: yup.mixed().required("Please upload allowance file"),
    }),
    ...(benefitFieldConfig && {
      Benefit: getAmountFieldSpec("Benefit", benefitMin, false),
      CurrencyCodeBenefit: yup.string(),
      benefitFile: yup.mixed(),
      // benefitFile: yup.mixed().required("Please upload benefit file"),
    }),
    ...(bonusFieldConfig && {
      Bonus: getAmountFieldSpec("Bonus", bonusMin, false),
      CurrencyCodeBonus: yup.string(),
      bonusFile: yup.mixed(),
      // bonusFile: yup.mixed().required("Please upload bonus file"),
    }),
    ...extraField.reduce(mapFieldValidate, {}),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ConditionType: ConditionType.Company,
      CurrencySalary: get(currencyCode, "0.currencyCodeID", ""),
      salary: "",
      salaryFile: undefined,
      // ContractTerm
      ContractTermType: "Y",
      ContractTermFile: undefined,
      ContractYear: "",
      ContractMonth: "",
      ContractPeriodFrom: "",
      ContractPeriodTo: "",
      ContractOther: "",
      Allowance: "",
      AverageIncomeBaht: "",
      CurrencyCodeAllowance: get(currencyCode, "0.currencyCodeID", ""),
      allowanceFile: undefined,
      Benefit: "",
      CurrencyCodeBenefit: get(currencyCode, "0.currencyCodeID", ""),
      benefitFile: undefined,
      Bonus: "",
      CurrencyCodeBonus: get(currencyCode, "0.currencyCodeID", ""),
      bonusFile: undefined,
      ...extraField.reduce((p, c) => ({ ...p, [c.conditionField]: "" }), {}),
    },
    validationSchema,
    onSubmit: async (values) => {
      const contractTermTypeList = {
        Y: ["ContractYear", "ContractMonth"],
        P: ["ContractPeriodFrom", "ContractPeriodTo"],
        O: ["ContractOther"],
      };
      const defaultType = get(fieldConfigState, "data.defaultType", []);
      const getFieldListConfig = defaultType.filter((field) =>
        [
          "CompanyType",
          "CurrencyCode",
          "ConditionType",
          // --
          "ContractTermType",
          "SalaryBaht",
          "SalaryEN",
          "AllowanceEN",
          "BenefitEN",
          "BonusEN",
          ...contractTermTypeList[values.ContractTermType],
          "Allowance",
          "Benefit",
          "Bonus",
          "CurrencySalary",
          "CurrencyCodeAllowance",
          "CurrencyCodeBenefit",
          "CurrencyCodeBonus",
          "AverageIncomeBaht",
        ].includes(field.smartName)
      );

      const withFloat = (n) => `${parseFloat(n).toFixed(2)}`;
      const calRate = (n, rate) => parseFloat(n) * rate;
      const getRate = (fieldName) => get(rates[fieldName], "rate", 0);

      const getValue = (field) => {
        if (field.smartName === "SalaryBaht") {
          return withFloat(get(values, "salary", 0));
        } else if (field.smartName === "SalaryEN") {
          return withFloat(
            calRate(get(values, "salary", 0), getRate("Salary"))
          );
        } else if (field.smartName === "Allowance") {
          return withFloat(get(values, "Allowance", 0));
        } else if (field.smartName === "AllowanceEN") {
          return withFloat(
            calRate(get(values, "Allowance", 0), getRate("Allowance"))
          );
        } else if (field.smartName === "Benefit") {
          return withFloat(get(values, "Benefit", 0));
        } else if (field.smartName === "BenefitEN") {
          return withFloat(
            calRate(get(values, "Benefit", 0), getRate("Benefit"))
          );
        } else if (field.smartName === "Bonus") {
          return withFloat(get(values, "Bonus", 0));
        } else if (field.smartName === "BonusEN") {
          return withFloat(calRate(get(values, "Bonus", 0), getRate("Bonus")));
        } else if (field.smartName === "ConditionType") {
          dispatch(setConditionType(values[field.smartName]));
          return `${values[field.smartName]}` || null;
        } else if (field.smartName === "AverageIncomeBaht") {
          const SalaryBaht = withFloat(
            calRate(get(values, "salary", 0), getRate("Salary"))
          );
          const Allowance = withFloat(
            calRate(get(values, "Allowance", 0), getRate("Allowance"))
          );
          const Benefit = withFloat(
            calRate(get(values, "Benefit", 0), getRate("Benefit"))
          );
          const Bonus = withFloat(
            calRate(get(values, "Bonus", 0), getRate("Bonus"))
          );

          const summary =
            parseFloat(Allowance || 0) +
            parseFloat(Benefit || 0) +
            parseFloat(Bonus || 0);

          const summaryWithSalary =
            parseFloat((summary || 0) / 12) + parseFloat(SalaryBaht || 0);
          const averageIncomeBaht = parseFloat(summaryWithSalary || 0).toFixed(
            2
          );

          return averageIncomeBaht;
        }

        return `${values[field.smartName]}` || null;
      };

      const prepareData = {
        draftId: null,
        smartserviceId: smartVisaServiceId,
        personalId: get(personalDetailState, "personalID", ""),
        survey: null,
        visaissuance: null,
        detail: [
          ...getFieldListConfig.map((field) => ({
            smartName: field.smartName,
            smartId: null,
            partfromId: field.partfromId,
            configsmartId: field.configsmartId,
            linkTable: "",
            value: getValue(field),
          })),
        ],
      };

      const getPrepareImage = (fieldConfig, fieldName) =>
        fieldConfig
          ? [
            {
              file: values[fieldName],
              personalID: get(personalDetailState, "personalID", null),
              conditionId: get(fieldConfig, "conditionId", null),
              configConditionVisaId: get(
                fieldConfig,
                "configConditionVisaId",
                null
              ),
            },
          ]
          : [];

      const prepareImages = [
        ...getPrepareImage(salaryFieldConfig, "salaryFile"),
        ...getPrepareImage(contractTermFieldConfig, "ContractTermFile"),
        ...getPrepareImage(allowanceFieldConfig, "allowanceFile"),
        ...getPrepareImage(benefitFieldConfig, "benefitFile"),
        ...getPrepareImage(bonusFieldConfig, "bonusFile"),
      ].filter(Boolean);

      const response = await dispatch(
        addPopupSmartForm({
          data: prepareData,
          images: prepareImages.length ? prepareImages : [],
        })
      );
      await dispatch(getSmartForm({ draftId: response?.payload?.draftId }))
      // onSubmit(values);
    },
  });

  const prevConditionType = usePrevious(formik.values.ConditionType);
  const currentConditionType = formik.values.ConditionType;

  useEffect(() => {
    if (prevConditionType !== currentConditionType) {
      dispatch(
        getCoditionVisa({
          smartVisaServiceId,
          ConditionType: currentConditionType,
        })
      );
    }
  }, [dispatch, smartVisaServiceId, currentConditionType, prevConditionType]);

  const getExchangeRate = async (Currency, field, fieldValidate) => {
    try {
      const res = await MasterService.getExchangeRate(
        new Date().toISOString(),
        Currency
      );
      setRates((rates) => ({
        ...rates,
        [field]: res.results,
      }));

      setTimeout(() => {
        formik.validateField(fieldValidate);
      }, 300);
    } catch (error) {
      console.log("error ", error);
    }
  };

  useEffect(() => {
    if (formik.values.CurrencySalary) {
      getExchangeRate(formik.values.CurrencySalary, "Salary", "salary");
    }
  }, [dispatch, formik.values.CurrencySalary, formik.values.ConditionType]);

  useEffect(() => {
    if (formik.values.CurrencyCodeAllowance) {
      getExchangeRate(
        formik.values.CurrencyCodeAllowance,
        "Allowance",
        "Allowance"
      );
    }
  }, [
    dispatch,
    formik.values.CurrencyCodeAllowance,
    formik.values.ConditionType,
  ]);

  useEffect(() => {
    if (formik.values.CurrencyCodeBenefit) {
      getExchangeRate(formik.values.CurrencyCodeBenefit, "Benefit", "Benefit");
    }
  }, [
    dispatch,
    formik.values.CurrencyCodeBenefit,
    formik.values.ConditionType,
  ]);

  useEffect(() => {
    if (formik.values.CurrencyCodeBonus) {
      getExchangeRate(formik.values.CurrencyCodeBonus, "Bonus", "Bonus");
    }
  }, [dispatch, formik.values.CurrencyCodeBonus, formik.values.ConditionType]);

  const prevSalaryFile = usePrevious(formik.values.salaryFile);
  const currentSalaryFile = formik.values.salaryFile;
  useEffect(() => {
    if (prevSalaryFile !== currentSalaryFile) {
      dispatch(readOCRSalary(currentSalaryFile));
    }
  }, [dispatch, prevSalaryFile, currentSalaryFile]);

  const prevContractTermFile = usePrevious(formik.values.ContractTermFile);
  const currentContractTermFile = formik.values.ContractTermFile;

  useEffect(() => {
    if (prevContractTermFile !== currentContractTermFile) {
      dispatch(readOCRContractTerm(currentContractTermFile));
    }
  }, [dispatch, currentContractTermFile, prevContractTermFile]);

  const preAllowanceFile = usePrevious(formik.values.allowanceFile);
  const currentAllowanceFile = formik.values.allowanceFile;

  useEffect(() => {
    if (preAllowanceFile !== currentAllowanceFile) {
      dispatch(readOCRAllowance(currentAllowanceFile));
    }
  }, [dispatch, currentAllowanceFile, preAllowanceFile]);

  const preBenefitFile = usePrevious(formik.values.benefitFile);
  const currentBenefitFile = formik.values.benefitFile;

  useEffect(() => {
    if (preBenefitFile !== currentBenefitFile) {
      dispatch(readOCRBenefit(currentBenefitFile));
    }
  }, [dispatch, currentBenefitFile, preBenefitFile]);

  const preBonusFile = usePrevious(formik.values.bonusFile);
  const currentBonusFile = formik.values.bonusFile;

  useEffect(() => {
    if (preBonusFile !== currentBonusFile) {
      dispatch(readOCRBonus(currentBonusFile));
    }
  }, [dispatch, currentBonusFile, preBonusFile]);

  const ocrSalaryState = useSelector(selectOCRSalary);
  const ocrContractTermState = useSelector(selectOCRContractTerm);

  const ocrAllowanceState = useSelector(selectOCRAllowance);
  const ocrBenefitState = useSelector(selectOCRBenefit);
  const ocrBonusState = useSelector(selectOCRBonus);

  const getUploadStatus = (uploadState, value, name, options) => {
    if (uploadState.isLoading) {
      return "recognizing";
    } else if (uploadState.isSuccess) {
      if (options.type === "number") {
        const checkWithOutFormat = uploadState.data
          .toLocaleLowerCase()
          .includes((value + "").toLocaleLowerCase());

        const checkWithFormat = uploadState.data
          .toLocaleLowerCase()
          .includes(formatPrice((value + "").toLocaleLowerCase()));

        console.log(`============== Check OCR for ${name} =============`);
        console.log("ORC data =>", uploadState.data);
        console.log("value =>", value);
        console.log(
          "Value for detect1 =>",
          value,
          " Detect Result =>",
          checkWithOutFormat
        );
        console.log(
          "Value for detect2 =>",
          formatPrice((value + "").toLocaleLowerCase()),
          " Detect Result =>",
          checkWithFormat
        );
        console.log("================================================");

        if (value + "" && (checkWithOutFormat || checkWithFormat)) {
          return "found";
        } else {
          return "notFound";
        }
      } else {
        console.log(`============== Check OCR for ${name} =============`);
        console.log("ORC data =>", uploadState.data);
        console.log("value =>", value);
        let matchSomeText;
        if (Array.isArray(value)) {
          matchSomeText = value.some((text) => {
            const matchText = uploadState.data
              .toLocaleLowerCase()
              .includes((value + "").toLocaleLowerCase());
            console.log(
              "Value for detect =>",
              text,
              " Detect Result =>",
              matchText
            );

            return matchText;
          });
        } else {
          matchSomeText = uploadState.data
            .toLocaleLowerCase()
            .includes((value + "").toLocaleLowerCase());
          console.log(
            "Value for detect =>",
            value,
            " Detect Result =>",
            matchSomeText
          );
        }

        console.log("================================================");
        if (value + "" && matchSomeText) {
          return "found";
        } else {
          return "notFound";
        }
      }
    } else if (uploadState.isFailure) {
      return "notFound";
    } else {
      return "idle";
    }
  };

  const contractTermTypeList = {
    Y: [formik.values.ContractYear, formik.values.ContractMonth],
    P: [formik.values.ContractPeriodFrom, formik.values.ContractPeriodTo],
    O: [formik.values.ContractOther],
  };

  const contractTermOCRText =
    contractTermTypeList[formik.values.ContractTermType] || "";

  const uploadSalaryStatus = getUploadStatus(
    ocrSalaryState,
    formik.values.salary,
    "salary",
    { type: "number" }
  );

  const uploadContractTermStatus = getUploadStatus(
    ocrContractTermState,
    contractTermOCRText,
    "contractTerm",
    { type: "string" }
  );

  const uploadAllowanceStatus = getUploadStatus(
    ocrAllowanceState,
    formik.values.Allowance,
    "Allowance",
    { type: "number" }
  );
  const uploadBenefitState = getUploadStatus(
    ocrBenefitState,
    formik.values.Benefit,
    "Benefit",
    { type: "number" }
  );
  const uploadBonusState = getUploadStatus(
    ocrBonusState,
    formik.values.Bonus,
    "Bonus",
    { type: "number" }
  );

  return (
    <div className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        QUALIFICATION ENDORSEMENT FOR SMART VISA “T”
      </Typography>
      <Typography variant="h4" color="secondary">
        Qualifications and Criteria
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1} style={{ marginTop: 30 }}>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" className={classes.label}>
              Please select only one
            </Typography>
            <FormControl variant="outlined" className={classes.formControl}>
              <Select
                value={formik.values.ConditionType}
                name="ConditionType"
                onChange={formik.handleChange}
                MenuProps={{
                  elevation: 2,
                  getContentAnchorEl: null,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "center",
                  },
                }}
              >
                {get(coditionType, "data", []).map((cdType) => (
                  <MenuItem
                    key={cdType.conditionType}
                    value={cdType.conditionType}
                  >
                    {cdType.conditionType}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={0} md={6}></Grid>

          {salaryFieldConfig && (
            <Grid item xs={12} md={6}>
              <Typography variant="h6" className={classes.label}>
                Salary
              </Typography>
              <div className={classes.flexRow}>
                <FormControl
                  variant="outlined"
                  className={classes.currencyCode}
                >
                  <Select
                    value={formik.values.CurrencySalary}
                    name="CurrencySalary"
                    onChange={formik.handleChange}
                    MenuProps={{
                      elevation: 2,
                      getContentAnchorEl: null,
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "center",
                      },
                    }}
                  >
                    {currencyCode.map((config) => (
                      <MenuItem
                        key={config.currencyCodeID}
                        value={config.currencyCodeID}
                      >
                        {config.currencyCodeID}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <CurrencyTextField
                  className={classes.formControl}
                  variant="outlined"
                  placeholder="Salary (Per month)"
                  currencySymbol=""
                  outputFormat="number"
                  name="salary"
                  value={formik.values.salary}
                  error={formik.touched.salary && Boolean(formik.errors.salary)}
                  helperText={formik.touched.salary && formik.errors.salary}
                  onChange={(event, value) =>
                    formik.setFieldValue("salary", value)
                  }
                  onBlur={formik.handleBlur}
                />
              </div>
            </Grid>
          )}
          {salaryFieldConfig && (
            <Grid item xs={12} md={4}>
              <Typography
                variant="h6"
                className={classes.label}
                style={{ whiteSpace: "nowrap" }}
              >
                Upload salary information (e.g. employment contract)
              </Typography>
              <UploadStatus status={uploadSalaryStatus} />

              {formik.touched.salaryFile && Boolean(formik.errors.salaryFile) && (
                <Typography
                  variant="caption"
                  color="error"
                  className={classes.errorText}
                >
                  {formik.errors.salaryFile}
                </Typography>
              )}
            </Grid>
          )}
          {salaryFieldConfig && (
            <Grid item xs={12} md={2}>
              <Typography variant="h6" className={classes.label}>
                {" "}
              </Typography>
              <UploadButton
                id="uploadSalary"
                disabled={Boolean(formik.errors.salary)}
                onChange={(event) =>
                  formik.setFieldValue("salaryFile", event.target.files[0])
                }
              />
              <Typography variant="caption" className={classes.errorText}>
                {" "}
              </Typography>
            </Grid>
          )}

          {contractTermFieldConfig && (
            <Grid item xs={12} md={6}>
              <Typography variant="h6" className={classes.label}>
                Contract term (Year)
              </Typography>
              <ContractTermSection formik={formik} />
            </Grid>
          )}
          {contractTermFieldConfig && (
            <Grid item xs={12} md={4}>
              <Typography
                variant="h6"
                className={classes.label}
                style={{ whiteSpace: "nowrap" }}
              >
                Upload contract information (e.g. employment contract)
              </Typography>
              <UploadStatus status={uploadContractTermStatus} />
              {formik.touched.ContractTermFile &&
                Boolean(formik.errors.ContractTermFile) && (
                  <Typography
                    variant="caption"
                    color="error"
                    className={classes.errorText}
                  >
                    {formik.errors.ContractTermFile}
                  </Typography>
                )}
            </Grid>
          )}
          {contractTermFieldConfig && (
            <Grid item xs={12} md={2} style={{ marginBottom: 40 }}>
              <Typography variant="h6" className={classes.label}>
                {" "}
              </Typography>
              <UploadButton
                id="uploadContractTerm"
                disabled={Boolean(formik.errors.contractTerm)}
                onChange={(event) =>
                  formik.setFieldValue(
                    "ContractTermFile",
                    event.target.files[0]
                  )
                }
              />
              <Typography variant="caption" className={classes.errorText}>
                {" "}
              </Typography>
            </Grid>
          )}
          {[
            allowanceFieldConfig && {
              label: "Allowance (Per year)",
              fieldName: "Allowance",
              fieldCurrencyCode: "CurrencyCodeAllowance",
              fileFieldName: "allowanceFile",
              fileUpLoadStatus: uploadAllowanceStatus,
            },
            benefitFieldConfig && {
              label: "Benefit (Per year)",
              fieldName: "Benefit",
              fieldCurrencyCode: "CurrencyCodeBenefit",
              fileFieldName: "benefitFile",
              fileUpLoadStatus: uploadBenefitState,
            },
            bonusFieldConfig && {
              label: "Bonus (Per year)",
              fieldName: "Bonus",
              fieldCurrencyCode: "CurrencyCodeBonus",
              fileFieldName: "bonusFile",
              fileUpLoadStatus: uploadBonusState,
            },
          ]
            .filter(Boolean)
            .map((field, index) => (
              <React.Fragment key={index}>
                <Grid item xs={12} md={6}>
                  <Typography variant="h6" className={classes.label}>
                    {field.label}
                  </Typography>
                  <div className={classes.flexRow}>
                    <FormControl
                      variant="outlined"
                      className={classes.currencyCode}
                    >
                      <Select
                        value={formik.values[field.fieldCurrencyCode]}
                        name={field.fieldCurrencyCode}
                        onChange={formik.handleChange}
                        MenuProps={{
                          elevation: 2,
                          getContentAnchorEl: null,
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "center",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "center",
                          },
                        }}
                      >
                        {currencyCode.map((config) => (
                          <MenuItem
                            key={config.currencyCodeID}
                            value={config.currencyCodeID}
                          >
                            {config.currencyCodeID}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <CurrencyTextField
                      className={classes.formControl}
                      variant="outlined"
                      placeholder={field.label}
                      currencySymbol=""
                      outputFormat="number"
                      name={field.fieldName}
                      value={formik.values[field.fieldName]}
                      error={
                        formik.touched[field.fieldName] &&
                        Boolean(formik.errors[field.fieldName])
                      }
                      helperText={
                        formik.touched[field.fieldName] &&
                        formik.errors[field.fieldName]
                      }
                      onChange={(event, value) =>
                        formik.setFieldValue(field.fieldName, value)
                      }
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="h6" className={classes.label}>
                    Upload {field.label}
                  </Typography>
                  <UploadStatus status={field.fileUpLoadStatus} />
                  {formik.touched[field.fileFieldName] &&
                    Boolean(formik.errors[field.fileFieldName]) && (
                      <Typography
                        variant="caption"
                        color="error"
                        className={classes.errorText}
                      >
                        {formik.errors[field.fileFieldName]}
                      </Typography>
                    )}
                </Grid>
                <Grid item xs={12} md={2}>
                  <Typography variant="h6" className={classes.label}>
                    {" "}
                  </Typography>
                  <UploadButton
                    id={field.fileFieldName}
                    disabled={Boolean(formik.errors[field.fieldName])}
                    onChange={(event) =>
                      formik.setFieldValue(
                        field.fileFieldName,
                        event.target.files[0]
                      )
                    }
                  />
                  <Typography variant="caption" className={classes.errorText}>
                    {" "}
                  </Typography>
                </Grid>
              </React.Fragment>
            ))}

          {extraField.map((field) => (
            <Grid item xs={12} md={6} key={field.conditionField}>
              <Typography variant="h6" className={classes.label}>
                {field.conditionField}
              </Typography>
              <TextField
                className={classes.formControl}
                variant="outlined"
                placeholder={field.conditionField}
                name={field.conditionField}
                type={
                  ["int", "double"].includes(field.conditionValue)
                    ? "number"
                    : "text"
                }
                value={formik.values[field.conditionField]}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError(field.conditionField, formik)}
                helperText={getErrorMessage(field.conditionField, formik)}
              />
            </Grid>
          ))}

          <Grid item xs={0} md={8}></Grid>
          <Grid item xs={12} md={2}>
            <ColorButton
              size="large"
              fullWidth
              variant="outlined"
              onClick={onCancel}
            >
              Cancel
            </ColorButton>
          </Grid>
          <Grid item xs={12} md={2}>
            <ColorButton
              size="large"
              fullWidth
              variant="contained"
              color="secondary"
              disabled={false}
              type="submit"
            >
              Next
            </ColorButton>
          </Grid>
        </Grid>
      </form>
    </div>
  );
}
